import * as v from 'valibot';
import { identifier, pii } from './domain-string.js';
import { AvailabilityConfig } from './profile.js';
import { Time, Weekday } from './shared.js';
import { Student } from './student.js';
export const ScheduleId = identifier('schedule-id');
export const ScheduleName = pii('schedule-name');
export const ScheduleSlot = v.object({
    student: Student,
    time: Time,
    weekday: Weekday,
});
export const Schedule = v.object({
    id: ScheduleId,
    name: ScheduleName,
    archived: v.optional(v.boolean(), false),
    availabilityConfig: AvailabilityConfig,
    slots: v.array(ScheduleSlot),
});
//# sourceMappingURL=schedule.js.map